import { EventData } from './types';

const API_BASE = 'https://67m7uq3175.execute-api.us-east-1.amazonaws.com/Prod';

export async function fetchEventData(eventId: string): Promise<EventData> {
  const response = await fetch(`${API_BASE}/api/USCAParsing/${eventId}`);
  if (!response.ok) {
    throw new Error(`API returned ${response.status}: ${response.statusText}`);
  }
  return response.json();
}
